module.exports = __webpack_public_path__ + "static/img/小米-小爱同学.66b16c60.png";